var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Accessibility'),_c('div',{class:'page_scale_'+_vm.$store.state.pageScale+' page_theme_'+_vm.$store.state.pageTheme},[_c('Header'),_c('div',{staticClass:"page"},[_c('keep-alive',{attrs:{"include":_vm.alivePages}},[_c('router-view')],1)],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }